import { useCallback } from 'preact/hooks';
import { useBlock, useConfigStore, useFormStore, useFormProps } from '@/features/form';
import Capture from './Capture';

export default function CaptureWrapper({ id }) {
	const { state, block, actions: blockActions } = useBlock({ id });
	const { formType, contentDivRef, screenshotActive, formOpen, actions } = useFormStore();
	const { text, themeClass } = useConfigStore();
	const { formKey } = useFormProps();

	const setScreenshot = useCallback(({ dom, selector, value }) => {
		blockActions.setNestedValue('dom', dom);
		blockActions.setNestedValue('selector', selector);
		blockActions.setValue(value);
	}, []);
	return (
		<Capture
			block={block}
			setScreenshot={setScreenshot}
			text={text}
			screenshotActive={formOpen && screenshotActive}
			showCapture={Boolean((formOpen && screenshotActive) || (formOpen && state.value))}
			toggleCapture={actions.toggleScreenshot}
			hideBackdrop={(formType === 'embed' && !screenshotActive) || !screenshotActive}
			contentDivRef={contentDivRef}
			formKey={formKey}
			themeClass={themeClass}
		/>
	);
}
